$ = require 'jquery'

module.exports = 

  $(document).ready(->

    #Box Click Event

    boxesArray = []
    boxClassesArray = []
    boxIndex = 0

    $(".portfolio-box").each(->
      boxesArray.push(this)
      $(boxesArray[boxIndex]).click(->
        boxClassesArray[boxIndex] = $(this).attr('class')
        boxNumber = boxClassesArray[boxIndex].slice(17)
        boxClicked(boxNumber)
      )      
      boxIndex++
    )

    totalBoxes = boxesArray.length
    
    hideAll = ->
      j = 0
      while ( j<=totalBoxes) 
        $(".item"+j).hide()
        j++
      
      $(".portfolio-next").hide()
    
    
    hideAllExcept = (itemNumber) ->
      $('.about-images').hide()
      hideAll()
      $(".item" + itemNumber).fadeIn('slow')
      $(".portfolio-next").fadeIn('slow')
    
    
    fadeAll = ->
      i = 0
      while ( i<=totalBoxes) 
        $(".item"+i).fadeOut()
        i++
      
    
    deselectAll = ->
      i = 0
      while ( i<=totalBoxes) 
        $(".box"+i).removeClass("selected")
        i++
      
    
    addPaddingToPortfolio = ->
      $('section.portfolio-content').animate(
        'padding-top': '30px'
        'padding-bottom': '30px'
      )
    
    removePaddingFromPortfolio = ->
      $('section.portfolio-content').animate(
        'padding-top': '0'
        'padding-bottom': '0'
      )
    
    scrollToPortfolio = ->
      # addPaddingToPortfolio()
       
      navHeight = $('nav.nav').outerHeight()
      portfolioContentTop = $('section.portfolio-content').position().top
      usableTop = 0

      #usableTop is a bugfix where portfolioContentTop
      #sometimes registers as 1259px for some reason
      if (portfolioContentTop > 300) 
        usableTop = 183
       else 
        usableTop = portfolioContentTop
      

      #Add padding to portfolio container, then scroll to top of portfolio.
      addPaddingToPortfolio().promise().then(-> 
        $('html, body').stop().animate(
          scrollTop: usableTop - navHeight
        )
      )
      
    
    prepNextButton = (nextItem) ->
      # $(".portfolio-next").unbind('click')
      # $(".portfolio-next").click(-> 
      #   boxClicked(nextItem)
      # )
      $(".portfolio-next").show()

      $(".portfolioitem-item").unbind('click')
      $(".portfolioitem-item").click(-> 
        boxClicked(nextItem)
      )
      #$(".portfolioitem-item").show()
      
    
    
    boxClicked = (boxNumber) ->
      #trim selected if applicable
      boxNum
      if (boxNumber.length > 3) 
        boxNum = boxNumber.substring(0, boxNumber.length-9)
        boxNumber = boxNum
      
      
      #Skip if it's the intro banner, or if it's been clicked already
      if ( (boxNumber != 0) && (lastBoxClicked == boxNumber) ) 
      
        console.log("Clicked Already")
        
      else

        if (boxNumber == 0)
          boxNumber = 1
        lastBoxClicked = boxNumber
        
        deselectAll()
        $(".box"+boxNumber).addClass("selected")
        
        $(".portfolio-next").hide()
        itemNumber = parseInt(boxNumber)
        nextItem = itemNumber + 1
        if (nextItem > totalBoxes) 
          nextItem = 1
        
        scrollToPortfolio()
        hideAllExcept(itemNumber)
        
        prepNextButton(nextItem)
      
      
    
    
    resetItems = ->
    hideAll()
    $('.about-images').show()
    
    resetItems()
    
    #Return to 3 boxes
    $(".nav-link-about, .nav-link-skillset, .nav-link-contact, .nav-link-logo").click(-> 
      introVisible = $('.about-images').css("display")
      
      if (introVisible == "none") 
        hideAll()
        deselectAll()
        $('.about-images').fadeIn('slow')
        removePaddingFromPortfolio()
      
    )
    
    $(".about-images").click(-> 
      boxClicked(0)
    )
    $(".nav-link-portfolio").click(-> 
      boxClicked(0)
    )
    
  )
